import { render, staticRenderFns } from "./ListConfigSearchArg.vue?vue&type=template&id=486f9e2d"
import script from "./ListConfigSearchArg.vue?vue&type=script&lang=js"
export * from "./ListConfigSearchArg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports